import Blockly from 'blockly'

//  创建字典有多少个键值对
Blockly.Blocks.dict_create_with = {
  init: function() {
    this.appendDummyInput().appendField('DT')
    this.setHelpUrl(Blockly.Msg['DICT_CREATE_WITH_HELPURL'])
    this.setStyle('dict_blocks')
    this.itemCount_ = 3
    this.updateShape_()
    this.setOutput(!0, 'Dict')
    this.setMutator(new Blockly.Mutator(['dict_create_with_item']))
    this.setTooltip('创建字典')
    this.setInputsInline(true)
    // this.setTooltip(Blockly.Msg.DICT_CREATE_WITH_TOOLTIP);
  },
  mutationToDom: function() {
    var a = document.createElement('mutation')
    a.setAttribute('items', this.itemCount_)
    return a
  },
  domToMutation: function(a) {
    this.itemCount_ = parseInt(a.getAttribute('items'), 10)
    this.updateShape_()
  },
  decompose: function(a) {
    var b = a.newBlock('dict_create_with_container')
    b.initSvg()
    for (
      var c = b.getInput('STACK').connection, d = 0;
      d < this.itemCount_;
      d++
    ) {
      var e = a.newBlock('dict_create_with_item')
      e.initSvg()
      c.connect(e.previousConnection)
      c = e.nextConnection
    }
    return b
  },
  compose: function(a) {
    var b = a.getInputTargetBlock('STACK')
    for (a = []; b; )
      a.push(b.valueConnection_),
        (b = b.nextConnection && b.nextConnection.targetBlock())
    for (b = 0; b < this.itemCount_; b++) {
      var c = this.getInput('ADD' + b).connection.targetConnection
      c && -1 == a.indexOf(c) && c.disconnect()
    }
    this.itemCount_ = a.length
    this.updateShape_()
    for (b = 0; b < this.itemCount_; b++)
      Blockly.Mutator.reconnect(a[b], this, 'ADD' + b)
  },
  saveConnections: function(a) {
    a = a.getInputTargetBlock('STACK')
    for (var b = 0; a; ) {
      var c = this.getInput('ADD' + b)
      a.valueConnection_ = c && c.connection.targetConnection
      b++
      a = a.nextConnection && a.nextConnection.targetBlock()
    }
  },
  updateShape_: function() {
    this.itemCount_ && this.getInput('EMPTY')
      ? this.removeInput('EMPTY')
      : this.itemCount_ ||
        this.getInput('EMPTY') ||
        this.appendDummyInput('EMPTY').appendField(
          Blockly.Msg.DICT_CREATE_EMPTY_TITLE
        )
    for (var a = 0; a < this.itemCount_; a++)
      if (!this.getInput('ADD' + a)) {
        var b = this.appendValueInput('ADD' + a)
        0 == a && b.appendField(Blockly.Msg.DICT_CREATE_WITH_INPUT_WITH)
      }
    for (; this.getInput('ADD' + a); ) this.removeInput('ADD' + a), a++
  },
}

Blockly.Blocks.dict_create_with_item = {
  init: function() {
    this.setColour(230)
    this.appendDummyInput().appendField(
      Blockly.Msg.LISTS_CREATE_WITH_ITEM_TITLE
    )
    this.setPreviousStatement(!0)
    this.setNextStatement(!0)
    this.setTooltip('...')
    this.setInputsInline(true)
    // this.setTooltip(Blockly.Msg.DICT_CREATE_WITH_ITEM_TOOLTIP);
    this.contextMenu = !1
  },
}
Blockly.Blocks.dict_create_with_container = {
  init: function() {
    this.setStyle('dict_blocks')
    // this.setColour(Blockly.Blocks.lists.HUE);
    this.appendDummyInput().appendField(
      Blockly.Msg.DICT_CREATE_WITH_CONTAINER_TITLE_ADD
    )
    this.appendStatementInput('STACK')
    this.setTooltip('s')
    this.setInputsInline(true)
    // this.setTooltip(Blockly.Msg.DICT_CREATE_WITH_CONTAINER_TOOLTIP);
    this.contextMenu = !1
  },
}

Blockly.Python.dict_create_with = function(a) {
  for (var b = Array(a.itemCount_), c = 0; c < a.itemCount_; c++)
    b[c] =
      Blockly.Python.valueToCode(a, 'ADD' + c, Blockly.Python.ORDER_NONE) ||
      'None'
  return ['{' + b.join(', ') + '}', Blockly.Python.ORDER_ATOMIC]
}

// 创建字典键值对
Blockly.Blocks.create_dict = {
  init: function() {
    this.appendDummyInput()
      .appendField('键为')
      .appendField(new Blockly.FieldTextInput(' '), 'name_1')
      .appendField('值为')
      .appendField(new Blockly.FieldTextInput(0), 'NAME')
    this.setOutput(true, null)
    this.setStyle('dict_blocks')
    this.setTooltip('这是一个键值对')
    this.setHelpUrl(Blockly.Msg['CREATE_DICT_HELPURL'])
    this.setOutput(true, 'String')
  },
}

Blockly.Python.create_dict = function(block) {
  var text_name_1 = block.getFieldValue('name_1')
  var number_name = block.getFieldValue('NAME')
  // TODO: Assemble JavaScript into code variable.
  var code = "'" + text_name_1 + "':'" + number_name + "'"
  // TODO: Change ORDER_NONE to the correct strength.
  return [code, Blockly.JavaScript.ORDER_NONE]
}

// 设置字典某个键的值
Blockly.Blocks.set_dict = {
  init: function() {
    this.appendDummyInput()
      .appendField(' 设置')
      .appendField(new Blockly.FieldVariable('DT'), 'dict')
      .appendField('键 ')
      .appendField(new Blockly.FieldTextInput('number'), 'key')
      .appendField('的值为')
      .appendField(new Blockly.FieldTextInput('1'), 'value')
    this.setInputsInline(true)
    this.setOutput(true, null)
    this.setStyle('dict_blocks')
    this.setTooltip('none')
    this.setHelpUrl(Blockly.Msg['SET_DICT_HELPURL'])
    this.setOutput(true, 'String')
  },
}

Blockly.Python.set_dict = function(block) {
  var variable_dict = Blockly.Python.variableDB_.getName(
    block.getFieldValue('dict'),
    Blockly.Variables.NAME_TYPE
  )
  var text_key = block.getFieldValue('key')
  var text_value = block.getFieldValue('value')
  // TODO: Assemble Python into code variable.
  var code = variable_dict + "['" + text_key + "']" + '=' + text_value
  // TODO: Change ORDER_NONE to the correct strength.
  return [code, Blockly.Python.ORDER_NONE]
}

// 删除字典属性
Blockly.Blocks.del_dict_key = {
  init: function() {
    this.appendDummyInput()
      .appendField('删除')
      .appendField(new Blockly.FieldVariable('DT'), 'dict')
      .appendField('中的')
      .appendField(new Blockly.FieldTextInput('number'), 'key')
    this.setOutput(true, null)
    this.setStyle('dict_blocks')
    this.setTooltip('none')
    this.setHelpUrl(Blockly.Msg['DEL_DICT_KEY_HELPURL'])
  },
}

Blockly.Python.del_dict_key = function(block) {
  var variable_dict = Blockly.Python.variableDB_.getName(
    block.getFieldValue('dict'),
    Blockly.Variables.NAME_TYPE
  )
  var text_key = block.getFieldValue('key')
  var code = 'del' + ' ' + variable_dict + "['" + text_key + "']"
  return [code, Blockly.Python.ORDER_NONE]
}

// 删除字典属性
Blockly.Blocks.del_dict_key_2 = {
  init: function() {
    this.appendDummyInput()
      .appendField('删除')
      .appendField(new Blockly.FieldVariable('DT'), 'dict')
      .appendField('中的')
    this.appendValueInput('key').setCheck(null)
    // .appendField(new Blockly.FieldTextInput("number"), "key");
    this.setInputsInline(true)
    this.setOutput(true, null)
    this.setStyle('dict_blocks')
    this.setTooltip('none')
    this.setHelpUrl(Blockly.Msg['DEL_DICT_KEY_2_HELPURL'])
  },
}

Blockly.Python.del_dict_key_2 = function(block) {
  var variable_dict = Blockly.Python.variableDB_.getName(
    block.getFieldValue('dict'),
    Blockly.Variables.NAME_TYPE
  )
//   var text_key = block.getFieldValue('key')
  var text_key= Blockly.Python.valueToCode(block, 'key', Blockly.Python.ORDER_NONE)
  var code = 'del' + ' ' + variable_dict + "[" + text_key + "]"
  return [code, Blockly.Python.ORDER_NONE]
}

// length of dict字典长度
Blockly.Blocks.length_of_dict = {
  init: function() {
    this.appendDummyInput()
      .appendField('字典')
      .appendField(new Blockly.FieldVariable('DT'), 'key')
      .appendField('键的总数')
    this.setInputsInline(true)
    this.setOutput(true, null)
    this.setStyle('dict_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['LENGTH_OF_DICT_HELPURL'])
  },
}
Blockly.Python.length_of_dict = function(block) {
  var variable_key = Blockly.Python.variableDB_.getName(
    block.getFieldValue('key'),
    Blockly.Variables.NAME_TYPE
  )
  // TODO: Assemble Python into code variable.
  var code = 'len(' + variable_key + ')'
  // TODO: Change ORDER_NONE to the correct strength.
  return [code, Blockly.Python.ORDER_NONE]
}

Blockly.Blocks.gta_ai_dict_include = {
  init: function() {
    this.appendDummyInput()
      .appendField(' 键')
      .appendField(new Blockly.FieldTextInput(''), 'NAME')
      // .setCheck("String")
      .appendField(' ')
    this.appendDummyInput()
      .appendField(
        new Blockly.FieldDropdown([
          ['存在于', 'in'],
          ['不存在于', 'not in'],
        ]),
        'NAME1'
      )
      .appendField(' ')
    this.appendValueInput('NAME2').setCheck(null)
    this.appendDummyInput().appendField(' ')
    this.setInputsInline(true)
    this.setOutput(true, 'Boolean')
    this.setStyle('dict_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['GET_AI_DICT_INCLUDE_HELPURL'])
  },
}

// 键值对是否存在于字典
Blockly.Python.gta_ai_dict_include = function(a) {
  var str = a.getFieldValue('NAME')
  var dropdown = a.getFieldValue('NAME1')
  var bvalue = Blockly.Python.valueToCode(
    a,
    'NAME2',
    Blockly.Python.ORDER_ATOMIC
  )
  var code = "('" + str + "' " + dropdown + ' ' + bvalue + ')'
  return [code, Blockly.Python.ORDER_NONE]
}

Blockly.Blocks.gta_ai_dict_include_2 = {
  init: function() {
    this.appendDummyInput().appendField(' 键')
    this.appendValueInput('NAME')
      .setCheck(null)
      .appendField(' ')
    this.appendDummyInput()
      .appendField(
        new Blockly.FieldDropdown([
          ['存在于', 'in'],
          ['不存在于', 'not in'],
        ]),
        'NAME1'
      )
      .appendField(' ')
    this.appendValueInput('NAME2').setCheck(null)
    this.appendDummyInput().appendField(' ')
    this.setInputsInline(true)
    this.setOutput(true, 'Boolean')
    this.setStyle('dict_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['GET_AI_DICT_INCLUDE_2_HELPURL'])
  },
}

// 键值对是否存在于字典
Blockly.Python.gta_ai_dict_include_2 = function(a) {
//   var str = a.getFieldValue('NAME')
  var str= Blockly.Python.valueToCode(a, 'NAME', Blockly.Python.ORDER_NONE)
  var dropdown = a.getFieldValue('NAME1')
  var bvalue = Blockly.Python.valueToCode(
    a,
    'NAME2',
    Blockly.Python.ORDER_ATOMIC
  )
  var code = "(" + str  + dropdown + ' ' + bvalue + ')'
  return [code, Blockly.Python.ORDER_NONE]
}

// 读取字典键的相应值
Blockly.Blocks.gta_ai_get_dict_key = {
  init: function() {
    this.appendDummyInput()
      .appendField('字典')
      .appendField(new Blockly.FieldVariable('DT'), 'dict')
      .appendField('键')
      .appendField(new Blockly.FieldTextInput(''), 'key')
      .appendField('的值')
    this.setOutput(true, null)
    this.setStyle('dict_blocks')
    this.setTooltip('读取字典键的相应值')
    this.setHelpUrl(Blockly.Msg['GTA_AI_GET_DICT_HELPURL'])
  },
}

Blockly.Python.gta_ai_get_dict_key = function(block) {
  var variable_dict = Blockly.Python.variableDB_.getName(
    block.getFieldValue('dict'),
    Blockly.Variables.NAME_TYPE
  )
  var text_key = block.getFieldValue('key')
  // TODO: Assemble Python into code variable.
  var code = variable_dict + '[' + "'" + text_key + "'" + ']'
  // TODO: Change ORDER_NONE to the correct strength.
  return [code, Blockly.Python.ORDER_NONE]
}

